export default "__VITE_ASSET__BEMulL8D__"